import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import {
  Modal,
  ModalHeader,
  ModalBody,
  useModalHandle,
  Button
} from '@spotahome/ui-library';

import './CancellationPolicyModal.scss';

const SECTIONS = [
  'landlord-rejects',
  'tenant-cancel-before-accept',
  'tenant-cancel-after-accept'
];

const getLabels = rangeLabel => ({
  title: `cancellationPolicy.info.${rangeLabel}.title`,
  text: `cancellationPolicy.info.${rangeLabel}.text`
});

const CancellationPolicySection = ({ section }) => {
  const labels = getLabels(section);

  return (
    <Fragment>
      <div className="cancellation-policy-modal__section-title">
        {trans(labels.title)}
      </div>
      <div
        className="cancellation-policy-modal__section-content"
        dangerouslySetInnerHTML={{ __html: trans(labels.text) }}
      />
    </Fragment>
  );
};

CancellationPolicySection.propTypes = {
  section: PropTypes.string.isRequired
};

const CancellationPolicyModal = () => {
  const { isModalOpen, handleModalOpen, handleModalClose } = useModalHandle();

  return (
    <Fragment>
      <Button
        color="link"
        onClick={handleModalOpen}
        className="ga-cancellation-policy"
        renderContent={() => trans('cancellation_policy.label.learn_more')}
      />

      <Modal
        isOpen={isModalOpen}
        size="medium"
        contentLabel="modal"
        ariaHideApp={false}
        onRequestClose={handleModalClose}
      >
        <ModalHeader
          className="cancellation-policy-modal__header"
          label={trans('cancellationPolicy.info.title')}
          onRequestClose={handleModalClose}
          dataCy="cancellation-policies-info-modal"
        />
        <ModalBody>
          <div className="cancellation-policy-modal">
            {SECTIONS.map(section => (
              <CancellationPolicySection section={section} key={section} />
            ))}
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default CancellationPolicyModal;
